import styled from "./Profile.module.css"
import Navbar from "../../../components/navbar/Navbar"
import { useState } from "react"
import CertificateModal from "./CertificateModal"
import { Link } from "react-router-dom"
import ProfileEditor from "./profileEditor/ProfileEditor"
import CertificateEditor from "./certificateEditor/CertificateEditor"

const Profile = () => {
  const [enlargedImg, setenlargedImg] = useState(null)

  const openCertModal = (imageURl) => {
    setenlargedImg(imageURl)
  }
  const closeCertModal = () => {
    setenlargedImg(null)
  }
  return (
    <>
    <Navbar />
    <div className={styled.container}>
         <div className={styled.personalInfo}>
          <div className={styled.leftSide}>
          <ProfileEditor />
          </div>
          <div className={styled.middleSide}>
          <CertificateEditor openCertModal={openCertModal}/>
          </div>
          <div className={styled.rightSide}>
            <h2>General Info</h2>
            <div className={styled.lists}>
            <li> <Link to="/completed-teacher-lessons">Completed Lessons</Link> </li>
            <li><Link to="/awaiting-teacher-lessons">Awaiting Lessons</Link></li>
            <li>
            <Link to={"/today-teacher-lessons"} className={styled.tdLessons}> Today's Lessons</Link>
            </li>
            <li> <Link to="/students">My Students</Link> </li>
            </div>
          </div>
         </div>
    </div>
      {enlargedImg && (
        <CertificateModal imageUrl={enlargedImg} onClose={closeCertModal} />
      )}
    </>
  )
}

export default Profile
